import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "react-hot-toast";
import "./App.css";

// Pages
import LoginPage from "./pages/LoginPage";
import DashboardPage from "./pages/DashboardPage";
import MonthDetailPage from "./pages/MonthDetailPage";
import TutorDetailPage from "./pages/TutorDetailPage";
import TutorPayrollDetailPage from "./pages/TutorPayrollDetailPage";
import TutorRatesPage from "./pages/TutorRatesPage";
import MentorsPage from "./pages/MentorsPage";
import CounselorsPage from "./pages/CounselorsPage";
import DemoLessonsPage from "./pages/DemoLessonsPage";
import WiseMappingPage from "./pages/WiseMappingPage";
import UsersPage from "./pages/UsersPage";

// Components
import Layout from "./components/Layout";
import PrivateRoute from "./components/PrivateRoute";
import { AuthProvider } from "./contexts/AuthContext";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      retry: 1,
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <Router>
        <AuthProvider>
          <div className="App">
            <Toaster
              position="top-right"
              toastOptions={{
                duration: 4000,
                style: {
                  background: "#363636",
                  color: "#fff",
                },
                success: {
                  duration: 3000,
                  iconTheme: {
                    primary: "#10b981",
                    secondary: "#fff",
                  },
                },
                error: {
                  duration: 5000,
                  iconTheme: {
                    primary: "#ef4444",
                    secondary: "#fff",
                  },
                },
              }}
            />
            <Routes>
              <Route path="/login" element={<LoginPage />} />

              <Route
                path="/"
                element={
                  <PrivateRoute>
                    <Layout />
                  </PrivateRoute>
                }
              >
                <Route index element={<Navigate to="/dashboard" replace />} />
                <Route path="dashboard" element={<DashboardPage />} />
                <Route path="tutors" element={<TutorRatesPage />} />
                <Route path="mentors" element={<MentorsPage />} />
                <Route path="counselors" element={<CounselorsPage />} />
                <Route path="demo-lessons" element={<DemoLessonsPage />} />
                <Route path="wise-mappings" element={<WiseMappingPage />} />
                <Route path="users" element={<UsersPage />} />
                <Route path="month/:yearMonth" element={<MonthDetailPage />} />
                <Route
                  path="month/:yearMonth/:tutorId"
                  element={<TutorPayrollDetailPage />}
                />
                <Route
                  path="tutor/:tutorId/:yearMonth"
                  element={<TutorDetailPage />}
                />
              </Route>
            </Routes>
          </div>
        </AuthProvider>
      </Router>
    </QueryClientProvider>
  );
}

export default App;
